<template lang='pug'>
  v-tooltip(bottom)
    template(v-slot:activator='{on}')
      v-btn.ma-0(v-on='on' text icon @click.stop.prevent='downloadXlsx')
        v-icon get_app
    span Download XLSX
</template>

<script>
import LoadTest from '@/api/loadTest';

export default {
  name: 'LoadTestDownload',
  props: {
    guid: {
      type: String
    },
    runGuid: {
      type: String
    }
  },
  methods: {
    async downloadXlsx() {
      const url = await LoadTest.downloadXlsx(this.guid, this.runGuid);
      window.location = url;
    }
  }
};
</script>

<style scoped>

</style>
